import { render, staticRenderFns } from "./DebtorsList.vue?vue&type=template&id=0816a943"
import script from "./DebtorsList.vue?vue&type=script&lang=js"
export * from "./DebtorsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports